module.exports = {"640425100":"白阳镇","640425101":"王洼镇","640425102":"古城镇","640425103":"红河镇","640425200":"新集乡","640425201":"城阳乡","640425203":"冯庄乡","640425204":"小岔乡","640425205":"孟塬乡","640425206":"罗洼乡","640425207":"交岔乡","640425208":"草庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640425.json
// module id = 3185
// module chunks = 0